import { useState, useContext } from "react"
import { GlobalContext } from "context/context/GlobalContext"
import { executeShipingGroupAction } from "services/ShippingGroupService"
import { TransactionCodeEnum } from "enums/TransactionCodeEnum"
import { NOTIFY_SHIPPED } from "helpers/constHelper"
import Logger from "classes/Logger"
import { ProcessShippingGroupActionType } from "types/OrderType"
import { EShippinggroupAction } from "enums/shippinggroupEmun"

const useDeliveryOrder = ({
  shippingGroupId,
  setFinishedShippingGroupAction,
}: ProcessShippingGroupActionType) => {
  const [loadingDelivey, setLoadingDelivery] = useState(false)

  const { notification, errorHander } = useContext(GlobalContext)

  const handleClickDeliveryOrder = async () => {
    setLoadingDelivery(true)

    try {
      const {
        data: { code },
      } = await executeShipingGroupAction({
        shippingGroupId,
        action: EShippinggroupAction.shipped,
      })

      setLoadingDelivery(false)

      if (code === TransactionCodeEnum.ok) {
        setFinishedShippingGroupAction(true)

        notification?.dispatch({
          type: "ADD_NOTIFICATION",
          payload: {
            message: "Productos despachados correctamente",
            title: NOTIFY_SHIPPED,
            type: "success",
          },
        })
      }
    } catch (error: any) {
      setLoadingDelivery(false)
      Logger.error(error)
      errorHander?.dispatch({ hasError: true, code: error.response?.status })
    }
  }

  return {
    handleClickDeliveryOrder,
    loadingDelivey,
  }
}

export default useDeliveryOrder
